export enum BillTypes {
  None = 0,
  Creditcard = 1,
  BankTransfer = 2,
  DirectDebit = 3,
  Cashless = 4,
  MessageLink = 5,
  Cash = 9,
}

export function getBillTypeName(value: BillTypes, isPaypal: boolean, noneName: string = '未指定'): string {
  switch (value) {
    case BillTypes.None: return noneName;
    case BillTypes.Creditcard: return isPaypal ? 'クレジットカード・PAYPAL' : 'クレジットカード';
    case BillTypes.BankTransfer: return '銀行振込';
    case BillTypes.DirectDebit: return '口座引落';
    case BillTypes.Cashless: return 'キャッシュレス';
    case BillTypes.MessageLink: return 'メッセージリンク';
    case BillTypes.Cash: return '現金';
  }
}

export function getBillTypes(includeNone: boolean = true): BillTypes[] {
  const list: BillTypes[] = [];
  for (const item in BillTypes) {
    if (!isNaN(Number(item))) {
      const num = Number(item);
      if (includeNone || num !== BillTypes.None) {
        list.push(num);
      }
    }
  }
  return list;
}
